import React from 'react';
import PropTypes from 'prop-types';
import { Button, Text, Link, SvgIcon } from 'components/elements';
import * as S from './styles';

function OppHeader({ name, handleApplyNow, buttonProps }) {
  return (
    <S.OppHeader>
      <S.InnerContainer>
        <Link iconLeft={<SvgIcon name="arrow" />} variant="link" to="/opportunities">
          Opportunities
        </Link>
        <Button handleClick={() => handleApplyNow()} width="full" {...buttonProps} />
      </S.InnerContainer>
      <Text variant="h1" colour="primary.700">
        {name}
      </Text>
    </S.OppHeader>
  );
}

OppHeader.propTypes = {
  name: PropTypes.string.isRequired,
  handleApplyNow: PropTypes.func.isRequired,
  buttonProps: PropTypes.shape({
    label: PropTypes.string,
    disabled: PropTypes.bool,
  }).isRequired,
};

export default OppHeader;
